import signout from 'src/screens/signout';
export default signout;
